export default __webpack_public_path__ + "static/media/42.32bce10f.jpg";